import { render, staticRenderFns } from "./DesignationList.vue?vue&type=template&id=cabba084"
import script from "./DesignationList.vue?vue&type=script&lang=js"
export * from "./DesignationList.vue?vue&type=script&lang=js"
import style0 from "./DesignationList.vue?vue&type=style&index=0&id=cabba084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports